module.exports = __webpack_public_path__ + "static/media/consciencia-negra.c1afeaf3.png";